export const SET_SELECTED_ROLES = 'SET_SELECTED_ROLES';
export const SET_ROLE_TO_PERMISSION = 'SET_ROLE_TO_PERMISSION';
export const SET_IS_HIDDEN_FOLDER = 'SET_IS_HIDDEN_FOLDER';
export const SET_NOTIFY = 'SET_NOTIFY';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_PERMISSION_ID = 'SET_PERMISSION_ID';
export const STEP2_RESET = 'STEP2_RESET';
export const RESET = 'RESET';
export const SET_SAVE_STATE = 'SET_SAVE_STATE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
const isPendingSave = (availability, selectedRoles, roleToPermission, isHidden) => {
    const numRolesChanged = selectedRoles ? selectedRoles.length : 0;
    const numRolesSet = roleToPermission ? roleToPermission.size : 0;
    const defaultIsHiddenVal = availability?.availability.includes('HIDDEN');
    const isHiddenChanged = isHidden !== defaultIsHiddenVal;
    return numRolesChanged + numRolesSet > 0 || isHiddenChanged;
};
export function advancedPermissionReducer(state, action) {
    const { type, ...payload } = action;
    switch (action.type) {
        case SET_SELECTED_ROLES:
            return {
                ...state,
                selectedRoles: action.selectedRoles,
                pendingSave: isPendingSave(state.availabilityStatus, action.selectedRoles, state.roleToPermission, state.isHidden),
            };
        case SET_ROLE_TO_PERMISSION:
            return {
                ...state,
                roleToPermission: action.roleToPermission,
                pendingSave: isPendingSave(state.availabilityStatus, state.selectedRoles, action.roleToPermission, state.isHidden),
            };
        case SET_IS_HIDDEN_FOLDER: {
            return {
                ...state,
                isHidden: action.isHidden,
                pendingSave: isPendingSave(state.availabilityStatus, state.selectedRoles, state.roleToPermission, action.isHidden),
            };
        }
        case SET_NOTIFY:
            return { ...state, notify: action.notify };
        case SET_MESSAGE:
            return { ...state, notifyMessage: action.notifyMessage };
        case SET_PERMISSION_ID:
            return { ...state, chosenPermission: action.chosenPermission };
        case SET_SAVE_STATE:
            return {
                ...state,
                saveState: action.saveState,
                availabilityStatus: action.availabilityStatus
                    ? action.availabilityStatus
                    : state.availabilityStatus,
            };
        case SET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                disableSave: action.disableSave,
            };
        case STEP2_RESET:
            return {
                ...state,
                ...payload,
                pendingSave: isPendingSave(state.availabilityStatus, payload.selectedRoles, state.roleToPermission, state.isHidden),
            };
        case RESET:
            return {
                ...state,
                ...payload,
            };
        default:
            throw new Error();
    }
}
//# sourceMappingURL=EntityAdvancedPermissionsState.js.map